// extracted by mini-css-extract-plugin
export var content = "cardSection-module--content--f9859";
export var title = "cardSection-module--title--972c2";
export var wrapper = "cardSection-module--wrapper--8985b";